import {OctTable, OctTableCollapse} from "@oceantech/oceantech-ui";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {Button} from "react-bootstrap";
import {SELECTION_MODE} from "../../../../utils/Constant";

interface Props {
  isView?: boolean;
  shouldNotShowActionTop?: boolean;
  title?: string;
  columns: any[];
  dsItems: any[];
}

const TableNhanLuc = (props: Props) => {
  const {dsItems, isView, title, columns,  shouldNotShowActionTop = false} = props;

  return (
    <div className="spaces mt-12 border-table custom-table">
      <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
        <div className=" bg-white flex align-items-center mr-13 spaces">
          <div className="title spaces ml-10">
            {title}
          </div>
        </div>
      </div>
      <OctTable
        id="table-tt-nhap-thuoc"
        className={`spaces custom-header-table table-nhan-luc`}
        columns={columns}
        data={dsItems}
        noToolbar
        clearToolbar
        noPagination
        fixedColumnsCount={-1}
      />


    </div>
  );
};

export default TableNhanLuc;
